import { useState } from 'react';
import { getChatMessages } from '../api/chatApi';
import { MessageReceivePayload } from '../datatypes';


interface UseChatMessagesResult {
    loading: boolean;
    error: string | null;
    fetchMessages: (chatId: string) => Promise<MessageReceivePayload[] | undefined>;
}

export function useChatMessages(): UseChatMessagesResult {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchMessages = async (chatId: string) => {
        setLoading(true);
        setError(null);
        try {
            const res = await getChatMessages(chatId);
            const fetchedMessages = res.data ? res.data as MessageReceivePayload[] : [];
            // const formattedMessages: MessageReceivePayload[] = fetchedMessages.map(msg => ({ ...msg, timestamp: msg.createdAt }));
            return fetchedMessages;
        } catch (e: any) {
            setError('Failed to fetch messages: ' + (e?.message || e));
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, fetchMessages };
} 